const parseToDateObj = (date?: string | null) => (date ? new Date(date) : new Date());

const mois = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Aout',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
];

const addMonths = (date: string, nbmonths: number) => {
  const dateObj = parseToDateObj(date);
  const d = dateObj.getDate();
  dateObj.setMonth(dateObj.getMonth() + nbmonths);
  if (dateObj.getDate() !== d) {
    dateObj.setDate(0);
  }
  return dateObj.toISOString().substr(0, 10);
};

const daysInMonth = (month: number, year: number) => new Date(year, month + 1, 0).getDate();

const lastDayOfMonthDate = (date: Date) => {
  const returnDate = new Date(date.getTime());
  returnDate.setMonth(returnDate.getMonth() + 1);
  returnDate.setDate(0);
  returnDate.setHours(23, 59, 59);
  return returnDate;
};

const currentDateTime = new Date();
// Time right now:
const dateTimeNow = `${currentDateTime.getDate()}/${
  currentDateTime.getMonth() + 1
}/${currentDateTime.getFullYear()} ${currentDateTime.getHours()}:${currentDateTime.getMinutes()}:${currentDateTime.getSeconds()}`;

const getFullTimeFunc = (dateToGet?: string | null) => {
  if (dateToGet) {
    const dateObj = parseToDateObj(dateToGet);
    return `${dateObj.getDate()}/${
      dateObj.getMonth() + 1
    }/${dateObj.getFullYear()} ${dateObj.getHours()}:${dateObj.getMinutes()}:${dateObj.getSeconds()}`;
  }
  return null;
};

const convertDate = (targetDate?: string | null) => {
  if (targetDate) {
    const target = parseToDateObj(targetDate);

    return target.toLocaleString(undefined, { dateStyle: 'short' });
  }
  return null;
};

const convertMonth = (targetDate?: string | null) => {
  if (targetDate) {
    const target = parseToDateObj(targetDate);

    return mois[target.getMonth()] + ' ' + target.getFullYear();
  }
  return '';
};

const convertTime = (targetDate?: string | null) => {
  if (targetDate) {
    const target = parseToDateObj(targetDate);
    return `${target.getHours()}h${
      target.getMinutes() < 10 ? `0${target.getMinutes()}` : target.getMinutes()
    }`;
  }
  return null;
};

/**
 * Today for tableau de bord since moment didnt translate on ios and android correctly
 */

const aujFunc = (jour?: number) => {
  const auj = new Date().getDay();
  switch (jour || auj) {
    case 0:
      return 'Dimanche';
    case 1:
      return 'Lundi';
    case 2:
      return 'Mardi';
    case 3:
      return 'Mercredi';
    case 4:
      return 'Jeudi';
    case 5:
      return 'Vendredi';
    case 6:
      return 'Samedi';
    default:
  }

  return '';
};
const yearFunc = () => {
  const mois = new Date().getMonth();
  switch (mois) {
    case 0:
      return 'Janvier';
    case 1:
      return 'Fevrier';
    case 2:
      return 'Mars';
    case 3:
      return 'Avril';
    case 4:
      return 'Mai';
    case 5:
      return 'Juin';
    case 6:
      return 'Juillet';
    case 7:
      return 'Août';
    case 8:
      return 'Septembre';
    case 9:
      return 'Octobre';
    case 10:
      return 'Novembre';
    case 11:
      return 'Decembre';
    default:
  }
  return () => {};
};
const today = `${aujFunc()} ${new Date().getDate()} ${yearFunc()} ${new Date().getFullYear()}`;

const getMinutes = (date?: Date) => {
  if (date === undefined || typeof date === 'string') {
    return 0;
  }
  return date.getHours() * 60 + date.getMinutes();
};

const displayHRTime = (minutes: number) => {
  const onTwoDigits = (myNumber: string | number) => ('0' + myNumber).slice(-2);
  return `${onTwoDigits(Math.floor(minutes / 60))}:${onTwoDigits(minutes % 60)}`;
};

const displayHRTimeWithH = (minutes: number) => {
  if (minutes === 0) return '0h00';
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours}h${mins.toString().padStart(2, '0')}`;
};

const getTimeSQLFormat = (date: Date) => {
  if (date === undefined) {
    return '00:00:00';
  }
  return displayHRTime(date.getHours() * 60 + date.getMinutes()) + ':00';
};

const getFromTimeSQLFormat = (string: string) => {
  if (string === undefined) {
    return string;
  }
  const date = new Date();
  const split = string.split(':');
  date.setHours(parseInt(split[0], 10), parseInt(split[1], 10), 0, 0);
  return date;
};

const getAge = (date?: string) => {
  if (date) {
    const today = new Date();

    const birthDate = parseToDateObj(date);
    const age = Math.floor((today.getTime() - birthDate.getTime()) / (1000 * 60 * 60 * 24 * 365));

    return `${age}`;
  }
  return '';
};

const formatDate = (date: Date) => {
  return date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate();
};

export default {
  formatDate,
  getAge,
  parseToDateObj,
  addMonths,
  daysInMonth,
  lastDayOfMonthDate,
  dateTimeNow,
  today,
  aujFunc,
  getFullTimeFunc,
  convertDate,
  convertTime,
  getMinutes,
  displayHRTime,
  displayHRTimeWithH,
  getTimeSQLFormat,
  getFromTimeSQLFormat,
  convertMonth,
};
